import { PRIMARY } from "./constants";

/** Field background (registration style). */
export const PROFILE_FIELD_BG = "#dce6f7";

/** TextField styling aligned with FE_application /registrazione. */
export const registrationTextFieldSx = {
  borderRadius: "8px",
  backgroundColor: PROFILE_FIELD_BG,
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    backgroundColor: PROFILE_FIELD_BG,
    "& fieldset": {
      border: "none",
    },
  },
  "& .MuiInputBase-input": {
    color: PRIMARY,
    fontStyle: "italic",
    padding: "14px",
  },
  "& .MuiInputLabel-root": {
    color: PRIMARY,
    fontStyle: "italic",
    fontSize: "0.95rem",
    textAlign: "left",
    paddingRight: "4px",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: PRIMARY,
  },
  "& .MuiFormHelperText-root": {
    color: "#e00036",
    marginLeft: 0,
    textAlign: "left",
  },
};

/** Read-only fields: same shell as edit mode, black semi-bold value text. */
export const profileReadOnlyTextFieldSx = {
  ...registrationTextFieldSx,
  "& .MuiInputBase-input": {
    color: PRIMARY,
    fontWeight: 600,
    fontStyle: "normal",
    padding: "14px",
    cursor: "default",
  },
  "& .MuiInputBase-input.Mui-readOnly": {
    color: PRIMARY, 
    WebkitTextFillColor: PRIMARY,
  },
};

/** Shared max-width + centering for profile field columns and section dividers. */
export const profileFieldsContentWidthSx = {
  width: "100%",
  maxWidth: { xs: "100%", sm: 920, md: 1100 },
  mx: "auto",
  my: { xs: 2, sm: 8 },
  boxSizing: "border-box",
};

/** Centers field grids within the profile card (like sede legale). */
export const profileFormGridSx = {
  ...profileFieldsContentWidthSx,
  alignItems: "flex-start",
};

export const profileFormColumnSpacing = { xs: 2, sm: 3 };
export const profileFormRowSpacing = { xs: 4, sm: 5.5 };

/** Vertical gap between major profile blocks (header, form card, delete section). */
export const profilePageSectionSpacing = { xs: 4, sm: 5 };

/** Value box fallback (e.g. empty payment list) — same field shell, read-only text. */
export const profileReadOnlyFieldBoxSx = {
  borderRadius: "8px",
  backgroundColor: PROFILE_FIELD_BG,
  px: "14px",
  py: "14px",
  minHeight: 48,
  width: "100%",
  display: "flex",
  alignItems: "center",
  boxSizing: "border-box",
};

export const profileReadOnlyValueSx = {
  fontFamily: "Rubik, sans-serif",
  fontSize: "0.95rem",
  fontStyle: "normal",
  fontWeight: 600,
  color: "#000000",
  textAlign: "left",
  wordBreak: "break-word",
  lineHeight: 1.5,
  width: "100%",
  m: 0,
};

export const profileCardSx = {
  p: { xs: 2, sm: 3, md: 6 },
  borderRadius: "20px",
  border: "1px solid rgba(0,0,0,0.06)",
  backgroundColor: "#ffffff",
  boxShadow: "0 0 9px rgba(0,0,0,0.08)",
};

export const profileSectionDividerSx = {
  ...profileFieldsContentWidthSx,
  my: { xs: 5, sm: 6.5 },
  borderColor: "divider",
};

export const profileFormFooterSx = {
  ...profileFieldsContentWidthSx,
  mt: 5,
  pt: 4,
  borderTop: "1px solid",
  borderColor: "divider",
};

/** Bottom padding when edit footer (Annulla/Conferma) is hidden. */
export const profileFormCardBottomGapSx = {
  ...profileFieldsContentWidthSx,
  pb: { xs: 4, sm: 5 },
};

export const profileSubsectionShellSx = profileFieldsContentWidthSx;

/** Extra sx for VatNumberField in profile (matches FormField / registrationTextField). */
export const profileVatNumberFieldSx = {
  
  "& .MuiOutlinedInput-root": {
    color: PRIMARY,
    height: 52,
    maxWidth: 280,
    "& fieldset": {
      border: "none",
    },
  },
  "& .MuiInputBase-input": {
    padding: "14px",
  },
  "& .MuiInputAdornment-root .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    py: "14px",
  },
};
